import React from 'react'
import { Link, useNavigate } from "react-router-dom"
import "../Styles/AssetCustodian.css"
import userRequest from "../../../utils/userRequest"
import { useState } from 'react'
import { handleUserError } from '../../../utils/error'
import { useEffect } from 'react'
import ViewportMeta from '../../../utils/ViewportMeta'
import Sidebarfats from '../../../components/sidebar/Sidebarfats'
import { useTranslation } from 'react-i18next'

const AssetCustodian = () => {
  const { t, i18n } = useTranslation()

  const [data, setData] = useState([]);
  const [employeeName, setEmployeeName] = useState("");

  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);


  const handleRowClick = (rowData, index) => {
    setSelectedRowIndex(index);
    setSelectedRow(rowData);

  };


  const navigate = useNavigate();

  const handleForm = (e) => {
    e.preventDefault();
  }

  const handleInputChanges = (event) => {
    if (event.target.name === 'EMPLOYEEID') {
      const EmpID = event.target.value;
      const data = {
        EmpID: EmpID,
      };
      userRequest.post("/getEmployeeListById", data)
        .then(response => {
          let data = response?.data?.recordset[0];
          console.log(response?.data)
          setEmployeeName(data?.EmpName ?? "")
        })
        .catch(error => {
          handleUserError(error)
          console.error(error);
        });

      userRequest.get(`/getAssetMasterEncodeAssetCaptureFinalByEmpId/${EmpID}`)
        .then(response => {
          setData(response?.data ?? []);
          setSelectedRow(response?.data[0] ?? []);

        })
        .catch(error => {
          handleUserError(error)
          console.error(error);
        })
    }
    event.preventDefault();
    setData((prev) => ({
      ...prev,
      [event.target.name]: event.target.value
    }))
    console.log(data);

  }

  const handleNextBtnClick = () => {
    console.log(selectedRow);
    if (selectedRow !== null) {
      console.log("working");
      localStorage.setItem("AssetData", JSON.stringify(selectedRow));
      localStorage.setItem("navigatePath", JSON.stringify('/cust'));
      navigate('/member/locationdetails')
    }
  }
  useEffect(() => {
    const AssetData = JSON.parse(localStorage.getItem('AssetData'));
    setSelectedRow(AssetData);
    localStorage.removeItem('AssetData');
    localStorage.removeItem('navigatePath');
  }, []);
  return (
    <>
      <div className={`p-0 h-full ${i18n.language === 'ar' ? 'sm:mr-72' : 'sm:ml-72'}`}>
          <ViewportMeta />
          <div className={`z-10 before:animate-pulse my-7 smm:my-10 before:bg-gradient-to-b before:from-gray-900 overflow-hidden before:via-[#00FF00] before:to-gray-900 ${i18n.language === 'ar' ? '2xl:ml-60 smm:mr-0' : '2xl:ml-60 smm:ml-0'}`}>
            <div className={`w-full h-auto px-3 sm:px-5 flex`}>
              <div className="w-full sm:w-1/2 lg:w-[900px] px-6 bg-gray-500 bg-opacity-20  backdrop-filter backdrop-blur-sm text-white z-10 py-4  rounded-lg">
                <div className="w-full flex justify-center text-black font-semibold text-xl mb:2 md:mb-5">
                  {t("ASSET BY CUSTODIAN")}
                </div>
                <form onSubmit={handleForm}>
                  <div className="mb-6">
                    <label htmlFor="emp" className={`block mb-2 text-xs font-medium text-black ${i18n.language === 'ar' ? 'text-end' : 'text-start'}`}>Employee ID</label>
                    <input
                      id="emp"
                      name="EMPLOYEEID"
                      onChange={handleInputChanges}
                      className={`bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500  ${i18n.language === 'ar' ? 'text-end' : 'text-start'}`}
                      placeholder={t('Employee ID')}
                    />
                  </div>

                  <div className="mb-6">
                    <input
                      value={employeeName}
                      placeholder={t('Employee Name')}
                      className={`bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500  ${i18n.language === 'ar' ? 'text-end' : 'text-start'}`}
                    />

                  </div>

                  <div className="mb-6">
                    <label htmlFor="assetlocationtag" className={`block mb-2 text-xs font-medium text-black ${i18n.language === 'ar' ? 'text-end' : 'text-start'}`}>{t("Asset Location Details")}</label>

                    {/* // creae excel like Tables  */}
                    <div className="table-custodian-generate">
                      <table className={` ${i18n.language === 'ar' ? 'direction-rtl' : 'direction-ltr'}`}>
                        <thead>
                          <tr>
                            <th>{t("Asset Discription")}</th>
                            <th>{t("Serial No")}</th>
                            <th>{t("Tags Number")}</th>
                            <th>{t("Minor Description")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.length > 0 &&
                            data.map((item, index) => {
                              return (
                                <tr
                                  key={index}
                                  onClick={() => handleRowClick(item, index)}
                                  style={{ backgroundColor: selectedRowIndex === index && 'orange' }}
                                >
                                  <td>{item.aSSETdESCRIPTION}</td>
                                  <td>{item.sERIALnUMBER}</td>
                                  <td>{item.TagNumber}</td>
                                  <td>{item.MinorCategoryDescription}</td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                  </div >

                  <div className="mb-6">
                    <span
                      // to='/locationdetails'
                      // to={selectedRow !== null ? '/locationdetails' : '#'}

                      // state={{
                      //   AssetData: selectedRow
                      // }}
                      onClick={handleNextBtnClick}
                    >
                      <button
                        className="bg-gray-300 hover:bg-gray-400 border border-gray-300 font-medium tracking-wider text-gray-900 text-xs rounded-lg block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      >
                        {t("Click the Asset For More Details")}
                      </button>
                    </span>
                  </div>

                  <div className={`mt-4 md:mt-10 flex justify-between items-center w-full text-sm md:text-xl py-2 rounded-md  ${i18n.language === 'ar' ? 'flex-row-reverse' : 'flex-row'}`}>
                    {/* <Link to='/assets'> */}
                    <button onClick={() => navigate('/member/assets')} type='submit' className="bg-[#00006B] text-white font-bold py-3 px-10 rounded-l">
                      {t("Back")}
                    </button>

                   <label htmlFor="total" className={`block text-xs font-medium text-black ${i18n.language==='ar'?' mr-8':'ml-8'}`}>{t("Total Assets")}</label>
                     <input
                      id="total"
                      value={data.length}
                      className="bg-gray-50 border text-center border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[50%] p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    />
                  </div>
                </form >
              </div >
            </div >
          </div >
      </div>
    </>
  )
}

export default AssetCustodian